import { useQuery } from '@tanstack/react-query';
import useUser from '../global/useUser';
import { getDiscounts } from '../../services/discounts';
import useFeatureGuard from '../subscriptions/useFeatureGuard';
import { Feature } from '../../types/subscriptions';

function useGetDiscounts({
  activeOnly = false,
}: { activeOnly?: boolean } = {}) {
  const { user } = useUser();
  const hasDiscountsFeature = useFeatureGuard(Feature.DISCOUNTS);

  const { data, isFetching, isLoading, isSuccess, isError, error, refetch } =
    useQuery({
      queryKey: ['discounts', user?.business?.id, user?.userId, !!activeOnly],
      queryFn: async () => {
        const result = await getDiscounts(user?.business?.id!, {
          activeOnly,
        });
        return result;
      },
      enabled: !!user?.business?.id && hasDiscountsFeature,
    });

  return {
    data,
    isFetching,
    isLoading,
    isSuccess,
    isError,
    error,
    refetch,
  };
}

export default useGetDiscounts;
